import { normalizeApiError, type NormalizedApiError } from "../../services/api.service.js";
import { canonicalComplaintErrorMessage, normalizeComplaintErrorCode } from "./cmtsComplaintErrorCatalog.js";

export type CmtsComplaintUiError = NormalizedApiError & {
  readonly complaintCode?: string | undefined;
  readonly userMessage: string;
  readonly isSodBlocked: boolean;
  readonly isEvidenceRejected: boolean;
  readonly isStaleSnapshot: boolean;
  readonly isTerminalStateConflict: boolean;
};

export function normalizeComplaintUiError(error: unknown, fallback = "Complaint lifecycle action failed."): CmtsComplaintUiError {
  const normalized = normalizeApiError(error);
  const complaintCode = normalizeComplaintErrorCode(normalized.errorCode) ?? normalizeComplaintErrorCode(normalized.envelope.code);
  const userMessage = canonicalComplaintErrorMessage(complaintCode, normalized.message || fallback);
  return {
    ...normalized,
    complaintCode,
    userMessage,
    isSodBlocked: complaintCode === "sod_blocked",
    isEvidenceRejected: complaintCode === "evidence_rejected" || complaintCode === "file_size_rejected" || complaintCode === "file_type_rejected",
    isStaleSnapshot: complaintCode === "stale_snapshot",
    isTerminalStateConflict: complaintCode === "terminal_state_conflict",
  };
}

export function complaintErrorMessage(error: unknown, fallback = "Complaint lifecycle action failed."): string {
  return normalizeComplaintUiError(error, fallback).userMessage;
}
